export const IMAGE_CATEGORIES = {
  "Ei kategoriaa": [
    "Ei aliluokkaa"
  ],  
  "Rakennetekniikka": [
    "Ei aliluokkaa",
    "Vierustat ja kuivatusosat",
    "Pihapäällysteet",
    "Aluevarusteet ja -rakenteet",
    "Perustukset ja sokkelit",
    "Alapohja",
    "Rakennusrunko",
    "Ulkoseinät",
    "Ikkunat",
    "Ulko-ovet",
    "Parvekkeet",
    "Kattorakenteet",
    "Sisätilat",
    "Märkätilat"
  ],
  "LVI-järjestelmät": [
    "Ei aliluokkaa",
    "Lämmöntuotanto",
    "Lämmitysverkosto",
    "Vesijohtoverkosto",
    "Viemäriverkosto",
    "Ilmanvaihtojärjestelmä",
    "Jäähdytysjärjestelmät",
    "Rakennusautomaatio",
    "Muut järjestelmät"
  ],
  "Sähköjärjestelmät": [
    "Ei aliluokkaa",
    "Aluesähköistys",
    "Kytkinlaitokset ja jakokeskukset",
    "Johdot ja niiden varusteet",
    "Valaisimet, lämmittimet, kojeet ja laitteet",
    "Tele- ja antennijärjestelmät",
    "Palo- ja turvajärjestelmät",
    "Siirtolaitteet"
  ],
  "Ikkunat kuntoarvio": [
    "Asuntojen ikkunat",
    "Yleisten tilojen ikkunat"
  ],
  "Ovet kuntoarvio": [
    "Asuntojen parvekeovet",
    "Yleisten tilojen ulko-ovet"
  ],
  "Julkisivut kuntoarvio": [],
  "Parvekkeet kuntoarvio": [],
  "Vesikatot kuntoarvio": [],
  "Kansikuva": [
    "Ei aliluokkaa"
  ],
  "Liitteet": [
    "Ei aliluokkaa"
  ],
  "Rappausnäytteet": [
    "Ei aliluokkaa"
  ],
  "Lähtötiedot ja havainnot": [
    "Ei aliluokkaa",
    "Asiakirjaluettelo",
    "Huoltotoimen arviointi",
    "Sisäolosuhteet",
    "Asukaskysely",
    "Tuhoeläimet",
    "Kosteusvaurioihin liittyvät havainnot"
  ],
  "Turvallisuus- ja ympäristöriskit": [
    "Ei aliluokkaa",
    "Rakennetekniikka",
    "LVI-järjestelmät",
    "Sähköjärjestelmät"
  ]
};

export const CATEGORY_NORMALIZATION = {
  rakenne: "Rakennetekniikka",
  lvi: "LVI-järjestelmät",
  sahko: "Sähköjärjestelmät",
  kansikuva: "Kansikuva"
};


export const normalizeCategory = (cat) => {
  // If category is empty or null, treat it as "Ei kategoriaa"
  if (!cat || cat.trim() === "") return "Ei kategoriaa";

  return CATEGORY_NORMALIZATION[cat] || cat;
};
